import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import { collection, addDoc, getDocs, query, orderBy } from "firebase/firestore";
import Navbar from "../inc/Navbar";

function Review() {
  const [name, setName] = useState("");
  const [review, setReview] = useState("");
  const [rating, setRating] = useState("5");
  const [reviews, setReviews] = useState([]);

  // 🔥 Fetch reviews from Firestore
  const fetchReviews = async () => {
    try {
      const q = query(collection(db, "reviews"), orderBy("date", "desc"));
      const snapshot = await getDocs(q);
      const reviewList = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));
      setReviews(reviewList);
    } catch (error) {
      console.log("Error fetching reviews:", error);
    }
  };

  useEffect(() => {
    fetchReviews(); // Load on first render
  }, []);

  // 🔥 Submit Review
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !review) return alert("Please fill all fields");

    try {
      await addDoc(collection(db, "reviews"), {
        name,
        review,
        rating,
        date: new Date(),
      });

      // Clear form
      setName("");
      setReview("");

      // Auto reload list
      fetchReviews();

      alert("Review Submitted!");
    } catch (error) {
      console.log("Submit error:", error);
    }
  };

  return (
    <div>
    <Navbar/>
    <br/>
    <br/>
      <br/>
    <br/>
  
      <div className="color">
    <div className="review-container " style={{ padding: "10px" }}>
      
      <h2  style={{color:"darkblue"}}>Submit Review</h2>

      <form onSubmit={handleSubmit}>
        <input className="review-input review-textarea"
          type="text"
          placeholder="Your Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <textarea className="review-input"
          placeholder="Your Review"
          value={review}
          onChange={(e) => setReview(e.target.value)}
        />

        <select className="review-input " value={rating} onChange={(e) => setRating(e.target.value)}>
          <option value="5">⭐ 5 Star</option>
          <option value="4">⭐ 4 Star</option>
          <option value="3">⭐ 3 Star</option>
          <option value="2">⭐ 2 Star</option>
          <option value="1">⭐ 1 Star</option>
        </select>

        <br/>
        <button className="review-btn mt-2" type="submit">Submit</button>
      </form>

      <hr />

      <h3>All Reviews</h3>

      {reviews.map((r) => (
        <div key={r.id} style={{
          marginBottom: "10px",
          padding: "10px",
          border: "1px solid #ccc"
        }}>
          <strong>{r.name}</strong> ({r.rating}⭐)
          <p>{r.review}</p>
  <p className="review-date">
  {new Date(r.date.seconds * 1000).toLocaleDateString("en-IN", {
    year: "numeric",
    month: "short",
    day: "numeric",
  })}{" "}
  at{" "}
  {new Date(r.date.seconds * 1000).toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
  })}
</p>

        </div>
      ))}
    </div>
    
      </div>
      </div>
  );
}

export default Review;
